<template>
  <div id="panel-sidenav">
    <div v-if="widget" class="panel-sidenav__title">
      <div class="facebook-pixel-container">
        <i :class="`panel-sidenav__icon ${$options.iconMap[widget.type]}`" />
        {{ widgetTranslatedName }}
        <i
          id="iframe-tooltip"
          class="fal fa-question-circle config-modal__pixel-icon"
          v-if="isIframe(widgetTranslatedName)"
        />
        <Tooltip target="iframe-tooltip" :text="iframeText" v-if="isIframe(widgetTranslatedName)" />
      </div>
    </div>

    <div class="panel-sidenav__content">
      <Input
        :value="active.title"
        :label="nameInputLabel"
        @enter="updateTitle({ id: active.id, value: $event })"
        @blur="updateTitle({ id: active.id, value: $event })"
        class="panel-sidenav__panel-title-input"
      />

      <div v-if="panels.length" class="panel-sidenav__content-title">
        Blocos do painel
      </div>

      <Content
        :id="active.id"
        :currentView="currentView"
        :carousel="options[currentView].carousel"
        :path="active.path"
        :panels="panels"
        :widget="widget"
      />

      <Divider v-if="!hasNoWidget" />

      <Collapsible
        v-if="!hasNoWidget"
        :label="$t('container-properties')"
        closedFaIcon="fa-chevron-down"
        openedFaIcon="fa-chevron-up"
      >
        <Layout :id="active.id" :title="active.title" :currentView="currentView" :options="options[currentView]" />
      </Collapsible>

      <Divider />

      <div class="panel-sidenav__buttons-container">
        <Button
          :buttonStyle="{ color: 'red' }"
          icon="fas fa-trash-alt"
          :label="removePanelButtonText"
          class="panel-sidenav__action-button"
          @click="removeContent"
        />

        <Button
          :buttonStyle="{ color: 'red' }"
          icon="fas fa-copy"
          :label="duplicatePanelButtonText"
          class="panel-sidenav__action-button"
          @click="duplicatePanel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Mixin from '@/components/sidenav/landing/Mixin.js'
import Content from '@/components/sidenav/landing/panel/Content.vue'
import Layout from '@/components/sidenav/landing/panel/Layout.vue'
import Collapsible from '@/shared/components/Collapsible'
import Button from '@/shared/components/Button'
import Divider from '@/shared/components/Divider'
import Input from '@/shared/components/Input'
import WidgetTranslateMap from '@/mixins/WidgetTranslateMap'

export default {
  name: 'PanelSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel-side-nav' },
  mixins: [Mixin, WidgetTranslateMap],
  components: {
    Content,
    Layout,
    Collapsible,
    Button,
    Divider,
    Input,
  },
  data() {
    return {
      iframeText:
        "Permite que você pegue um site ou HTML e coloque-o dentro do bloco da seção. <a href='https://ajuda.herospark.com/support/solutions/articles/69000534325-como-configurar-iframe-na-p%C3%A1gina/preview' target='_blank'>Veja mais sobre como usar o iFrame</a>.",
    }
  },
  computed: {
    ...mapState('landing', ['panelCopied']),
    ...mapGetters('landing', ['panels', 'widget', 'objectById']),
    current() {
      return this.objectById(this.active.id)
    },
    parentId() {
      return this.current.path ? this.current.path[this.current.path.length - 1] : null
    },
    hasNoWidget() {
      return !this.widget && !this.panels.length
    },
    widgetTranslatedName() {
      return this.$options.widgetTranslateMap[this.widget.type]
    },
    nameInputLabel() {
      return this.widget ? 'Nome do componente' : 'Nome do painel'
    },
    removePanelButtonText() {
      return this.widget ? 'Deletar componente' : 'Deletar painel'
    },
    duplicatePanelButtonText() {
      return this.widget ? 'Duplicar componente' : 'Duplicar painel'
    },
  },
  methods: {
    ...mapActions('landing', ['setPanelToCopy', 'pastePanel', 'removeWidget', 'removePanel', 'updateTitle']),
    removeContent() {
      this.hasNoWidget ? this.removePanel({ id: this.active.id }) : this.removeWidget({ id: this.widget.id })
    },
    duplicatePanel() {
      this.setPanelToCopy(this.active.id)

      this.pastePanel({ id: this.panelCopied, parentId: this.parentId })
    },
    isIframe(text) {
      return text.toUpperCase() === 'IFRAME'
    },
  },
}
</script>

<style lang="scss">
.panel-sidenav__title {
  background-color: white;
  text-align: center;
  padding: 8px;
  border-bottom: 1px solid $grey-20;
}

.panel-sidenav__content-title {
  line-height: 1.5rem;
  color: $grey;
  font-weight: 700;
  padding-left: 8px;
  padding-top: 8px;
}

.panel-sidenav__icon {
  color: $cherry;
  margin-right: 8px;
}

.panel-sidenav__content {
  margin-top: 16px;
}

.panel-sidenav__buttons-container {
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 32px;
}

.panel-sidenav__action-button {
  margin-top: 16px;
}

.panel-sidenav__panel-title-input {
  padding-left: 8px;
  padding-right: 8px;
}
</style>
